import { render, staticRenderFns } from "./mainView.vue?vue&type=template&id=d0a04e30&scoped=true&"
import script from "./mainView.vue?vue&type=script&lang=js&"
export * from "./mainView.vue?vue&type=script&lang=js&"
import style0 from "./mainView.vue?vue&type=style&index=0&id=d0a04e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a04e30",
  null
  
)

export default component.exports